var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref, watch } from "vue";
import { jobLockStatus, jobLockUpdate } from "@/api/jobs";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobLock',
    setup(__props) {
        const jobLock = ref(false);
        const jobLockUpdating = ref(true);
        watch(jobLock, (newVal) => __awaiter(this, void 0, void 0, function* () {
            jobLockUpdating.value = true;
            const { data } = yield jobLockUpdate({ active: jobLock.value });
            jobLock.value = data.active;
            jobLockUpdating.value = false;
        }));
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            // TODO: see if we can upstream an optional arg when no params are required?
            // i.e. jobLockStatus() instead of jobLockStatus({})
            const response = yield jobLockStatus({});
            jobLock.value = response.data.active;
            jobLockUpdating.value = false;
        }));
        return { __sfc: true, jobLock, jobLockUpdating };
    }
});
